'use client';

import React__default from 'react';
import { ChipWrapper } from './Chip.css.js';
import { DEFAULT_LIGHT_COLOR, DEFAULT_COLOR } from './constants.js';

var Chip = function (props) {
    var _a = props.color, color = _a === void 0 ? 'default' : _a, _b = props.isLightColor, isLightColor = _b === void 0 ? false : _b, _c = props.children, children = _c === void 0 ? '' : _c, _d = props.isHaveIcon, isHaveIcon = _d === void 0 ? true : _d;
    // Get color info
    var filteredColors = (isLightColor ? DEFAULT_LIGHT_COLOR : DEFAULT_COLOR).filter(function (item) { return item.name === color; });
    var colorInfo = isLightColor ? DEFAULT_LIGHT_COLOR[0] : DEFAULT_COLOR[0];
    if (filteredColors.length > 0) {
        colorInfo = filteredColors[0];
    }
    return (React__default.createElement(ChipWrapper, { color: colorInfo.color, backgroundColor: colorInfo.backgroundColor, isHaveIcon: isHaveIcon },
        isHaveIcon && colorInfo.icon,
        children));
};

export { Chip as default };
//# sourceMappingURL=index.js.map
